import { c as _c } from "react/compiler-runtime";
import { DEFAULT_VRAM_KB } from '@/constants/device';
import { useConfigsContext } from '@/context/ConfigsContext';
import { DeviceType } from '@/types/configs';
export const useTotalVramKb = deviceType => {
  const $ = _c(5);
  const {
    appConfig
  } = useConfigsContext();
  let t0;
  if ($[0] !== appConfig?.features?.device_to_vram) {
    t0 = appConfig?.features?.device_to_vram || [];
    $[0] = appConfig?.features?.device_to_vram;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const deviceToVram = t0;
  let t1;
  if ($[2] !== deviceToVram || $[3] !== deviceType) {
    t1 = deviceToVram?.find(device => device.device === deviceType)?.top_vram_kb || DEFAULT_VRAM_KB;
    $[2] = deviceToVram;
    $[3] = deviceType;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const totalVramKb = t1;
  return totalVramKb;
};